// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var ListRecordHistoriesRequest_SortOptions;
(function (ListRecordHistoriesRequest_SortOptions) {
    ListRecordHistoriesRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListRecordHistoriesRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListRecordHistoriesRequest_SortOptions["DELETED_AT"] = "DELETED_AT";
})(ListRecordHistoriesRequest_SortOptions || (ListRecordHistoriesRequest_SortOptions = {}));
export var ListRecordHistoriesRequest_SortOptions_index;
(function (ListRecordHistoriesRequest_SortOptions_index) {
    ListRecordHistoriesRequest_SortOptions_index[ListRecordHistoriesRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListRecordHistoriesRequest_SortOptions_index[ListRecordHistoriesRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListRecordHistoriesRequest_SortOptions_index[ListRecordHistoriesRequest_SortOptions_index["DELETED_AT"] = 2] = "DELETED_AT";
})(ListRecordHistoriesRequest_SortOptions_index || (ListRecordHistoriesRequest_SortOptions_index = {}));
export var ListRecordHistoriesRequest_PageDirection;
(function (ListRecordHistoriesRequest_PageDirection) {
    ListRecordHistoriesRequest_PageDirection["PAGE_FORWARD"] = "PAGE_FORWARD";
    ListRecordHistoriesRequest_PageDirection["PAGE_BACKWARD"] = "PAGE_BACKWARD";
})(ListRecordHistoriesRequest_PageDirection || (ListRecordHistoriesRequest_PageDirection = {}));
export var ListRecordHistoriesRequest_PageDirection_index;
(function (ListRecordHistoriesRequest_PageDirection_index) {
    ListRecordHistoriesRequest_PageDirection_index[ListRecordHistoriesRequest_PageDirection_index["PAGE_FORWARD"] = 0] = "PAGE_FORWARD";
    ListRecordHistoriesRequest_PageDirection_index[ListRecordHistoriesRequest_PageDirection_index["PAGE_BACKWARD"] = 1] = "PAGE_BACKWARD";
})(ListRecordHistoriesRequest_PageDirection_index || (ListRecordHistoriesRequest_PageDirection_index = {}));
export var ListAppointmentsRequest_SortOptions;
(function (ListAppointmentsRequest_SortOptions) {
    ListAppointmentsRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListAppointmentsRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListAppointmentsRequest_SortOptions["ARCHIVED_AT"] = "ARCHIVED_AT";
    ListAppointmentsRequest_SortOptions["ENTERED_AT"] = "ENTERED_AT";
    ListAppointmentsRequest_SortOptions["CANCELED_AT"] = "CANCELED_AT";
    ListAppointmentsRequest_SortOptions["APPOINTMENT_AT"] = "APPOINTMENT_AT";
})(ListAppointmentsRequest_SortOptions || (ListAppointmentsRequest_SortOptions = {}));
export var ListAppointmentsRequest_SortOptions_index;
(function (ListAppointmentsRequest_SortOptions_index) {
    ListAppointmentsRequest_SortOptions_index[ListAppointmentsRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListAppointmentsRequest_SortOptions_index[ListAppointmentsRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListAppointmentsRequest_SortOptions_index[ListAppointmentsRequest_SortOptions_index["ARCHIVED_AT"] = 2] = "ARCHIVED_AT";
    ListAppointmentsRequest_SortOptions_index[ListAppointmentsRequest_SortOptions_index["ENTERED_AT"] = 3] = "ENTERED_AT";
    ListAppointmentsRequest_SortOptions_index[ListAppointmentsRequest_SortOptions_index["CANCELED_AT"] = 4] = "CANCELED_AT";
    ListAppointmentsRequest_SortOptions_index[ListAppointmentsRequest_SortOptions_index["APPOINTMENT_AT"] = 5] = "APPOINTMENT_AT";
})(ListAppointmentsRequest_SortOptions_index || (ListAppointmentsRequest_SortOptions_index = {}));
export var ListAppointmentsRequest_PageDirection;
(function (ListAppointmentsRequest_PageDirection) {
    ListAppointmentsRequest_PageDirection["PAGE_FORWARD"] = "PAGE_FORWARD";
    ListAppointmentsRequest_PageDirection["PAGE_BACKWARD"] = "PAGE_BACKWARD";
})(ListAppointmentsRequest_PageDirection || (ListAppointmentsRequest_PageDirection = {}));
export var ListAppointmentsRequest_PageDirection_index;
(function (ListAppointmentsRequest_PageDirection_index) {
    ListAppointmentsRequest_PageDirection_index[ListAppointmentsRequest_PageDirection_index["PAGE_FORWARD"] = 0] = "PAGE_FORWARD";
    ListAppointmentsRequest_PageDirection_index[ListAppointmentsRequest_PageDirection_index["PAGE_BACKWARD"] = 1] = "PAGE_BACKWARD";
})(ListAppointmentsRequest_PageDirection_index || (ListAppointmentsRequest_PageDirection_index = {}));
export var AppointmentFilterOption_FilterType;
(function (AppointmentFilterOption_FilterType) {
    AppointmentFilterOption_FilterType["UNSPECIFIED"] = "UNSPECIFIED";
    AppointmentFilterOption_FilterType["TYPE"] = "TYPE";
    AppointmentFilterOption_FilterType["STATUS"] = "STATUS";
    AppointmentFilterOption_FilterType["PRACTITIONER"] = "PRACTITIONER";
    AppointmentFilterOption_FilterType["OPERATORY"] = "OPERATORY";
    AppointmentFilterOption_FilterType["SOURCE_TENANT"] = "SOURCE_TENANT";
})(AppointmentFilterOption_FilterType || (AppointmentFilterOption_FilterType = {}));
export var AppointmentFilterOption_FilterType_index;
(function (AppointmentFilterOption_FilterType_index) {
    AppointmentFilterOption_FilterType_index[AppointmentFilterOption_FilterType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    AppointmentFilterOption_FilterType_index[AppointmentFilterOption_FilterType_index["TYPE"] = 2] = "TYPE";
    AppointmentFilterOption_FilterType_index[AppointmentFilterOption_FilterType_index["STATUS"] = 3] = "STATUS";
    AppointmentFilterOption_FilterType_index[AppointmentFilterOption_FilterType_index["PRACTITIONER"] = 4] = "PRACTITIONER";
    AppointmentFilterOption_FilterType_index[AppointmentFilterOption_FilterType_index["OPERATORY"] = 5] = "OPERATORY";
    AppointmentFilterOption_FilterType_index[AppointmentFilterOption_FilterType_index["SOURCE_TENANT"] = 6] = "SOURCE_TENANT";
})(AppointmentFilterOption_FilterType_index || (AppointmentFilterOption_FilterType_index = {}));
export var ListRecallsRequest_SortOptions;
(function (ListRecallsRequest_SortOptions) {
    ListRecallsRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListRecallsRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListRecallsRequest_SortOptions["ARCHIVED_AT"] = "ARCHIVED_AT";
    ListRecallsRequest_SortOptions["EVENT_AT"] = "EVENT_AT";
})(ListRecallsRequest_SortOptions || (ListRecallsRequest_SortOptions = {}));
export var ListRecallsRequest_SortOptions_index;
(function (ListRecallsRequest_SortOptions_index) {
    ListRecallsRequest_SortOptions_index[ListRecallsRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListRecallsRequest_SortOptions_index[ListRecallsRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListRecallsRequest_SortOptions_index[ListRecallsRequest_SortOptions_index["ARCHIVED_AT"] = 2] = "ARCHIVED_AT";
    ListRecallsRequest_SortOptions_index[ListRecallsRequest_SortOptions_index["EVENT_AT"] = 3] = "EVENT_AT";
})(ListRecallsRequest_SortOptions_index || (ListRecallsRequest_SortOptions_index = {}));
export var ListRecallsRequest_PageDirection;
(function (ListRecallsRequest_PageDirection) {
    ListRecallsRequest_PageDirection["PAGE_FORWARD"] = "PAGE_FORWARD";
    ListRecallsRequest_PageDirection["PAGE_BACKWARD"] = "PAGE_BACKWARD";
})(ListRecallsRequest_PageDirection || (ListRecallsRequest_PageDirection = {}));
export var ListRecallsRequest_PageDirection_index;
(function (ListRecallsRequest_PageDirection_index) {
    ListRecallsRequest_PageDirection_index[ListRecallsRequest_PageDirection_index["PAGE_FORWARD"] = 0] = "PAGE_FORWARD";
    ListRecallsRequest_PageDirection_index[ListRecallsRequest_PageDirection_index["PAGE_BACKWARD"] = 1] = "PAGE_BACKWARD";
})(ListRecallsRequest_PageDirection_index || (ListRecallsRequest_PageDirection_index = {}));
export var RecallFilterOption_FilterType;
(function (RecallFilterOption_FilterType) {
    RecallFilterOption_FilterType["UNSPECIFIED"] = "UNSPECIFIED";
    RecallFilterOption_FilterType["INTEGRATION_TENANT"] = "INTEGRATION_TENANT";
    RecallFilterOption_FilterType["TYPE"] = "TYPE";
    RecallFilterOption_FilterType["SOURCE_TENANT"] = "SOURCE_TENANT";
    RecallFilterOption_FilterType["STATUS"] = "STATUS";
})(RecallFilterOption_FilterType || (RecallFilterOption_FilterType = {}));
export var RecallFilterOption_FilterType_index;
(function (RecallFilterOption_FilterType_index) {
    RecallFilterOption_FilterType_index[RecallFilterOption_FilterType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RecallFilterOption_FilterType_index[RecallFilterOption_FilterType_index["INTEGRATION_TENANT"] = 1] = "INTEGRATION_TENANT";
    RecallFilterOption_FilterType_index[RecallFilterOption_FilterType_index["TYPE"] = 2] = "TYPE";
    RecallFilterOption_FilterType_index[RecallFilterOption_FilterType_index["SOURCE_TENANT"] = 3] = "SOURCE_TENANT";
    RecallFilterOption_FilterType_index[RecallFilterOption_FilterType_index["STATUS"] = 4] = "STATUS";
})(RecallFilterOption_FilterType_index || (RecallFilterOption_FilterType_index = {}));
export var ListOrdersRequest_SortOptions;
(function (ListOrdersRequest_SortOptions) {
    ListOrdersRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListOrdersRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListOrdersRequest_SortOptions["ARCHIVED_AT"] = "ARCHIVED_AT";
    ListOrdersRequest_SortOptions["EVENT_AT"] = "EVENT_AT";
})(ListOrdersRequest_SortOptions || (ListOrdersRequest_SortOptions = {}));
export var ListOrdersRequest_SortOptions_index;
(function (ListOrdersRequest_SortOptions_index) {
    ListOrdersRequest_SortOptions_index[ListOrdersRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListOrdersRequest_SortOptions_index[ListOrdersRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListOrdersRequest_SortOptions_index[ListOrdersRequest_SortOptions_index["ARCHIVED_AT"] = 2] = "ARCHIVED_AT";
    ListOrdersRequest_SortOptions_index[ListOrdersRequest_SortOptions_index["EVENT_AT"] = 3] = "EVENT_AT";
})(ListOrdersRequest_SortOptions_index || (ListOrdersRequest_SortOptions_index = {}));
export var ListOrdersRequest_PageDirection;
(function (ListOrdersRequest_PageDirection) {
    ListOrdersRequest_PageDirection["PAGE_FORWARD"] = "PAGE_FORWARD";
    ListOrdersRequest_PageDirection["PAGE_BACKWARD"] = "PAGE_BACKWARD";
})(ListOrdersRequest_PageDirection || (ListOrdersRequest_PageDirection = {}));
export var ListOrdersRequest_PageDirection_index;
(function (ListOrdersRequest_PageDirection_index) {
    ListOrdersRequest_PageDirection_index[ListOrdersRequest_PageDirection_index["PAGE_FORWARD"] = 0] = "PAGE_FORWARD";
    ListOrdersRequest_PageDirection_index[ListOrdersRequest_PageDirection_index["PAGE_BACKWARD"] = 1] = "PAGE_BACKWARD";
})(ListOrdersRequest_PageDirection_index || (ListOrdersRequest_PageDirection_index = {}));
export var OrderFilterOption_FilterType;
(function (OrderFilterOption_FilterType) {
    OrderFilterOption_FilterType["UNSPECIFIED"] = "UNSPECIFIED";
    OrderFilterOption_FilterType["INTEGRATION_TENANT"] = "INTEGRATION_TENANT";
    OrderFilterOption_FilterType["TYPE"] = "TYPE";
    OrderFilterOption_FilterType["STATUS"] = "STATUS";
    OrderFilterOption_FilterType["SOURCE_TENANT"] = "SOURCE_TENANT";
})(OrderFilterOption_FilterType || (OrderFilterOption_FilterType = {}));
export var OrderFilterOption_FilterType_index;
(function (OrderFilterOption_FilterType_index) {
    OrderFilterOption_FilterType_index[OrderFilterOption_FilterType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    OrderFilterOption_FilterType_index[OrderFilterOption_FilterType_index["INTEGRATION_TENANT"] = 1] = "INTEGRATION_TENANT";
    OrderFilterOption_FilterType_index[OrderFilterOption_FilterType_index["TYPE"] = 2] = "TYPE";
    OrderFilterOption_FilterType_index[OrderFilterOption_FilterType_index["STATUS"] = 3] = "STATUS";
    OrderFilterOption_FilterType_index[OrderFilterOption_FilterType_index["SOURCE_TENANT"] = 4] = "SOURCE_TENANT";
})(OrderFilterOption_FilterType_index || (OrderFilterOption_FilterType_index = {}));
export var ListPersonsRequest_SortOptions;
(function (ListPersonsRequest_SortOptions) {
    ListPersonsRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListPersonsRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListPersonsRequest_SortOptions["DELETED_AT"] = "DELETED_AT";
    ListPersonsRequest_SortOptions["ENTERED_AT"] = "ENTERED_AT";
})(ListPersonsRequest_SortOptions || (ListPersonsRequest_SortOptions = {}));
export var ListPersonsRequest_SortOptions_index;
(function (ListPersonsRequest_SortOptions_index) {
    ListPersonsRequest_SortOptions_index[ListPersonsRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListPersonsRequest_SortOptions_index[ListPersonsRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListPersonsRequest_SortOptions_index[ListPersonsRequest_SortOptions_index["DELETED_AT"] = 2] = "DELETED_AT";
    ListPersonsRequest_SortOptions_index[ListPersonsRequest_SortOptions_index["ENTERED_AT"] = 3] = "ENTERED_AT";
})(ListPersonsRequest_SortOptions_index || (ListPersonsRequest_SortOptions_index = {}));
export var ListPersonsRequest_PageDirection;
(function (ListPersonsRequest_PageDirection) {
    ListPersonsRequest_PageDirection["PAGE_FORWARD"] = "PAGE_FORWARD";
    ListPersonsRequest_PageDirection["PAGE_BACKWARD"] = "PAGE_BACKWARD";
})(ListPersonsRequest_PageDirection || (ListPersonsRequest_PageDirection = {}));
export var ListPersonsRequest_PageDirection_index;
(function (ListPersonsRequest_PageDirection_index) {
    ListPersonsRequest_PageDirection_index[ListPersonsRequest_PageDirection_index["PAGE_FORWARD"] = 0] = "PAGE_FORWARD";
    ListPersonsRequest_PageDirection_index[ListPersonsRequest_PageDirection_index["PAGE_BACKWARD"] = 1] = "PAGE_BACKWARD";
})(ListPersonsRequest_PageDirection_index || (ListPersonsRequest_PageDirection_index = {}));
export var PersonFilterOption_FilterType;
(function (PersonFilterOption_FilterType) {
    PersonFilterOption_FilterType["UNSPECIFIED"] = "UNSPECIFIED";
    PersonFilterOption_FilterType["INTEGRATION_TENANT"] = "INTEGRATION_TENANT";
    PersonFilterOption_FilterType["STATUS"] = "STATUS";
    PersonFilterOption_FilterType["SOURCE_TENANT"] = "SOURCE_TENANT";
})(PersonFilterOption_FilterType || (PersonFilterOption_FilterType = {}));
export var PersonFilterOption_FilterType_index;
(function (PersonFilterOption_FilterType_index) {
    PersonFilterOption_FilterType_index[PersonFilterOption_FilterType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    PersonFilterOption_FilterType_index[PersonFilterOption_FilterType_index["INTEGRATION_TENANT"] = 1] = "INTEGRATION_TENANT";
    PersonFilterOption_FilterType_index[PersonFilterOption_FilterType_index["STATUS"] = 2] = "STATUS";
    PersonFilterOption_FilterType_index[PersonFilterOption_FilterType_index["SOURCE_TENANT"] = 3] = "SOURCE_TENANT";
})(PersonFilterOption_FilterType_index || (PersonFilterOption_FilterType_index = {}));
export var ListContactInfosRequest_SortOptions;
(function (ListContactInfosRequest_SortOptions) {
    ListContactInfosRequest_SortOptions["MODIFIED_AT"] = "MODIFIED_AT";
    ListContactInfosRequest_SortOptions["CREATED_AT"] = "CREATED_AT";
    ListContactInfosRequest_SortOptions["ARCHIVED_AT"] = "ARCHIVED_AT";
})(ListContactInfosRequest_SortOptions || (ListContactInfosRequest_SortOptions = {}));
export var ListContactInfosRequest_SortOptions_index;
(function (ListContactInfosRequest_SortOptions_index) {
    ListContactInfosRequest_SortOptions_index[ListContactInfosRequest_SortOptions_index["MODIFIED_AT"] = 0] = "MODIFIED_AT";
    ListContactInfosRequest_SortOptions_index[ListContactInfosRequest_SortOptions_index["CREATED_AT"] = 1] = "CREATED_AT";
    ListContactInfosRequest_SortOptions_index[ListContactInfosRequest_SortOptions_index["ARCHIVED_AT"] = 2] = "ARCHIVED_AT";
})(ListContactInfosRequest_SortOptions_index || (ListContactInfosRequest_SortOptions_index = {}));
export var ListContactInfosRequest_PageDirection;
(function (ListContactInfosRequest_PageDirection) {
    ListContactInfosRequest_PageDirection["PAGE_FORWARD"] = "PAGE_FORWARD";
    ListContactInfosRequest_PageDirection["PAGE_BACKWARD"] = "PAGE_BACKWARD";
})(ListContactInfosRequest_PageDirection || (ListContactInfosRequest_PageDirection = {}));
export var ListContactInfosRequest_PageDirection_index;
(function (ListContactInfosRequest_PageDirection_index) {
    ListContactInfosRequest_PageDirection_index[ListContactInfosRequest_PageDirection_index["PAGE_FORWARD"] = 0] = "PAGE_FORWARD";
    ListContactInfosRequest_PageDirection_index[ListContactInfosRequest_PageDirection_index["PAGE_BACKWARD"] = 1] = "PAGE_BACKWARD";
})(ListContactInfosRequest_PageDirection_index || (ListContactInfosRequest_PageDirection_index = {}));
export var ContactInfoFilterOption_FilterType;
(function (ContactInfoFilterOption_FilterType) {
    ContactInfoFilterOption_FilterType["UNSPECIFIED"] = "UNSPECIFIED";
    ContactInfoFilterOption_FilterType["INTEGRATION_TENANT"] = "INTEGRATION_TENANT";
    ContactInfoFilterOption_FilterType["TYPE"] = "TYPE";
    ContactInfoFilterOption_FilterType["SOURCE_TENANT"] = "SOURCE_TENANT";
})(ContactInfoFilterOption_FilterType || (ContactInfoFilterOption_FilterType = {}));
export var ContactInfoFilterOption_FilterType_index;
(function (ContactInfoFilterOption_FilterType_index) {
    ContactInfoFilterOption_FilterType_index[ContactInfoFilterOption_FilterType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ContactInfoFilterOption_FilterType_index[ContactInfoFilterOption_FilterType_index["INTEGRATION_TENANT"] = 1] = "INTEGRATION_TENANT";
    ContactInfoFilterOption_FilterType_index[ContactInfoFilterOption_FilterType_index["TYPE"] = 2] = "TYPE";
    ContactInfoFilterOption_FilterType_index[ContactInfoFilterOption_FilterType_index["SOURCE_TENANT"] = 3] = "SOURCE_TENANT";
})(ContactInfoFilterOption_FilterType_index || (ContactInfoFilterOption_FilterType_index = {}));
export const MetlHistoryService = {
    /**
     * ListRecordHistories returns a filtered, paged and sorted list of record history entries.
     */
    ListRecordHistories(fn, req) {
        return fn(`/messaging/etl/history/v1/record-histories?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListAppointments returns a list of appointments and allows for filtering by various fields.
     */
    ListAppointments(fn, req) {
        return fn(`/messaging/etl/history/v1/appointments?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * AppointmentFilterOptions returns a list of all possible values for various fields on appointments to filter by.
     */
    AppointmentFilterOptions(fn, req) {
        return fn(`/messaging/etl/history/v1/appointments/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * AppointmentHistory returns the history of changes over time to an appointment.
     */
    AppointmentHistory(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentId"], "appointmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/etl/history/v1/appointments/${req["appointmentId"]}/history?${fm.renderURLSearchParams(req, ["appointmentId"])}`, { method: "GET" });
    },
    /**
     * ListRecalls returns a list of recalls and allows for filtering by various fields.
     */
    ListRecalls(fn, req) {
        return fn(`/messaging/etl/history/v1/recalls?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * RecallFilterOptions returns a list of all possible values for various fields on recalls to filter by.
     */
    RecallFilterOptions(fn, req) {
        return fn(`/messaging/etl/history/v1/recalls/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * RecallHistory returns the history of changes over time to a recall.
     */
    RecallHistory(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/etl/history/v1/recalls/${req["eventId"]}/history?${fm.renderURLSearchParams(req, ["eventId"])}`, { method: "GET" });
    },
    /**
     * ListOrders returns a list of orders and allows for filtering by various fields.
     */
    ListOrders(fn, req) {
        return fn(`/messaging/etl/history/v1/orders?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * OrderFilterOptions returns a list of all possible values for various fields on orders to filter by.
     */
    OrderFilterOptions(fn, req) {
        return fn(`/messaging/etl/history/v1/orders/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * OrderHistory returns the history of changes over time to an order.
     */
    OrderHistory(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/etl/history/v1/orders/${req["eventId"]}/history?${fm.renderURLSearchParams(req, ["eventId"])}`, { method: "GET" });
    },
    /**
     * ListPersons returns a list of persons and allows for filtering by various fields.
     */
    ListPersons(fn, req) {
        return fn(`/messaging/etl/history/v1/persons?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * PersonFilterOptions returns a list of all possible values for various fields on perons to filter by.
     */
    PersonFilterOptions(fn, req) {
        return fn(`/messaging/etl/history/v1/persons/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * PersonHistory returns the history of changes over time to a person.
     */
    PersonHistory(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/etl/history/v1/persons/${req["personId"]}/history?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    /**
     * ListContactInfos returns a list of contact infos and allows for filtering by various fields.
     */
    ListContactInfos(fn, req) {
        return fn(`/messaging/etl/history/v1/contact-infos?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ContactInfoFilterOptions returns a list of all possible values for various fields on contact infos to filter by.
     */
    ContactInfoFilterOptions(fn, req) {
        return fn(`/messaging/etl/history/v1/contact-infos/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ContactInfoHistory returns the history of changes over time to a contact info.
     */
    ContactInfoHistory(fn, req) {
        try {
            fm.validateUrlParam(req["contactInfoId"], "contactInfoId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/etl/history/v1/contact-infos/${req["contactInfoId"]}/history?${fm.renderURLSearchParams(req, ["contactInfoId"])}`, { method: "GET" });
    },
};
